"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhoneInput;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _material = require("@mui/material");
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _matchSorter = require("match-sorter");
var _react = _interopRequireWildcard(require("react"));
var _parse = require("../../utils/parse");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    container: {
      minWidth: '85px'
    },
    error: {
      '& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root::before': {
        borderBottom: "none !important"
      },
      '& > .MuiAutocomplete-root .MuiFormControl-root label': {
        color: "".concat(theme.palette.error.main, " !important")
      },
      '&.MuiPaper-root:focus-within': {
        '& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root::before': {
          borderBottom: "none!important"
        },
        '& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root:after': {
          borderBottom: "none !important"
        },
        border: "2px solid ".concat(theme.palette.error.main, " !important")
      },
      '&:hover': {
        borderColor: "".concat(theme.palette.error.main, " !important")
      },
      border: "1px solid ".concat(theme.palette.error.main, " !important")
    },
    helper: {
      margin: '0 14px'
    },
    input: {
      flex: 1,
      marginLeft: theme.spacing(1)
    },
    option: {
      '& > span': {
        fontSize: 18,
        marginRight: 10
      },
      fontSize: 15
    },
    paper: {
      width: '250px'
    },
    root: {
      '& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root::after': {
        borderBottom: "none !important"
      },
      '& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root::before': {
        borderBottom: "none !important"
      },
      '& input.MuiInputBase-input.MuiAutocomplete-input': {
        textAlign: 'center'
      },
      '&:focus-within': {
        '& > .MuiAutocomplete-root .MuiFormControl-root label': {
          color: "".concat(theme.palette.info.dark)
        },
        border: "2px solid ".concat(theme.palette.primary.main, " !important"),
        borderWidth: '2px',
        padding: '6px'
      },
      '&:hover': {
        borderColor: theme.palette.text.primary
      },
      alignItems: 'center',
      border: "1px solid ".concat(theme.palette.action.disabled),
      boxShadow: 'none',
      boxSizing: 'border-box',
      display: 'flex',
      padding: '7px',
      width: '100%'
    },
    select: {
      '& .MuiAutocomplete-inputRoot': {
        marginTop: '0px'
      },
      '& > label': {
        backgroundColor: theme.palette.background.paper,
        color: "".concat(theme.palette.text.secondary),
        left: 0,
        maxWidth: '300%',
        padding: '0 5px',
        position: 'absolute',
        top: '-1em'
      }
    }
  };
});
var filteredCountries = function filteredCountries(countries, _ref) {
  var inputValue = _ref.inputValue;
  return inputValue === '' ? countries : (0, _matchSorter.matchSorter)(countries, inputValue, {
    keys: [{
      key: 'code',
      threshold: _matchSorter.rankings.EQUAL
    }, {
      key: function key(country) {
        return country.callingCode.substring(1);
      },
      threshold: _matchSorter.rankings.STARTS_WITH
    }, {
      key: 'callingCode',
      threshold: _matchSorter.rankings.STARTS_WITH
    }, 'name'],
    threshold: _matchSorter.rankings.ACRONYM
  });
};
function PhoneInput(_ref2) {
  var _meta$data, _input$value;
  var callingCodePlaceholder = _ref2.callingCodePlaceholder,
    countries = _ref2.countries,
    defaultCountry = _ref2.defaultCountry,
    disabled = _ref2.disabled,
    input = _ref2.input,
    label = _ref2.label,
    meta = _ref2.meta,
    phoneNumberPlaceholder = _ref2.phoneNumberPlaceholder;
  var classes = useStyles();
  var error = meta.error || !meta.modifiedSinceLastSubmit && ((_meta$data = meta.data) == null ? void 0 : _meta$data.submitError);
  var value = (_input$value = input.value) !== null && _input$value !== void 0 ? _input$value : '';
  var _useState = (0, _react.useState)(defaultCountry),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    country = _useState2[0],
    setCountry = _useState2[1];
  var _parsePhoneNumber = (0, _parse.parsePhoneNumber)(value, countries, country, false),
    _parsePhoneNumber$cal = _parsePhoneNumber.callingCode,
    callingCode = _parsePhoneNumber$cal === void 0 ? '' : _parsePhoneNumber$cal,
    code = _parsePhoneNumber.code,
    phoneNumber = _parsePhoneNumber.phoneNumber;
  if (code !== (country == null ? void 0 : country.code)) {
    setCountry(countries.find(function (option) {
      return option.code === code;
    }));
  }
  if (phoneNumber.length === 0) {
    input.onChange(undefined);
  }
  var onCountryChange = function onCountryChange(e, newCountry) {
    setCountry(newCountry);
    input.onChange(newCountry.callingCode + phoneNumber);
  };
  var onPhoneNumberChange = function onPhoneNumberChange(e) {
    var newPhoneNumber = e.target.value.trim('');
    if (newPhoneNumber.startsWith('+')) {
      setCountry(null);
      input.onChange(newPhoneNumber);
    } else {
      input.onChange(callingCode + newPhoneNumber);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: "".concat(classes.root, " ").concat(meta.touched && error && classes.error)
  }, /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
    autoHighlight: true,
    classes: {
      option: classes.option,
      paper: classes.paper
    },
    className: classes.container,
    disableClearable: true,
    disabled: disabled,
    filterOptions: filteredCountries,
    getOptionLabel: function getOptionLabel(option) {
      return option.callingCode;
    },
    onChange: onCountryChange,
    options: countries,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({
        className: classes.select,
        variant: "standard"
      }, params, {
        InputLabelProps: {
          shrink: true
        },
        inputProps: (0, _extends2.default)({}, params.inputProps, {
          autoComplete: 'phone-prefix'
        }),
        label: label,
        placeholder: callingCodePlaceholder
      }));
    },
    renderOption: function renderOption(optionProps, option) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
        component: "li"
      }, optionProps, {
        key: option.code
      }), "".concat(option.name, " (").concat(option.code, ") ").concat(option.callingCode));
    },
    value: country !== null && country !== void 0 ? country : null
  }), /*#__PURE__*/_react.default.createElement(_material.InputBase, (0, _extends2.default)({}, input, {
    className: classes.input,
    disabled: disabled,
    error: Boolean(meta.touched && (error || meta.warning)),
    onChange: onPhoneNumberChange,
    placeholder: phoneNumberPlaceholder,
    type: "tel",
    value: phoneNumber
  }))), meta.touched && error && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    className: classes.helper,
    error: true
  }, error));
}